module.exports = __webpack_public_path__ + "static/img/role001.8d03a94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role001.jpg
// module id = OKkQ
// module chunks = 1